import type { Events } from '@/utils/event-bus'
import createNewId from '@/utils/random-id'

const EVENT_NAME_MAP: Record<keyof Events, string> = {
  add_save_item: 'Add Save Item',
  remove_save_item: 'Remove Save Item',
  print_page: 'Print Page',
}

const track = (name: string, payload: Record<string, string | number>) => {
  if (!window?.klaviyo) return
  window.klaviyo.track(name, payload)
}

export const addSaveItemKlaviyo = (event: Events['add_save_item']) => {
  const uid = createNewId()
  track(EVENT_NAME_MAP['add_save_item'], { ...event, uid })
}

export const removeSaveItemKlaviyo = (event: Events['remove_save_item']) => {
  const uid = createNewId()
  track(EVENT_NAME_MAP['remove_save_item'], { ...event, uid })
}

export const printPageKlaviyo = (event: Events['print_page']) => {
  const uid = createNewId()
  track(EVENT_NAME_MAP['print_page'], { ...event, uid })
}
